import styled from "styled-components";
import { useState } from "react";
import { Icon } from "components";

const CopyButton = styled.div`
  ${({ theme: { colors } }) => `
    border-radius: 0.5rem;
    background: ${colors("link")};
    margin: 0.25rem;
    padding: 0.25rem;
    text: ${colors("background")};
    display: flex;
    justify-content: center;
    align-items: center;
  `}
`;

const TextContainer = styled.div`
  ${({ theme: { colors } }) => `
    font-size: 0.75rem;
    padding: 0.5rem;
    display: flex;
    align-items: center;
  `}
`;

export const CopyText = ({ children }) => {
  const [copied, setCopied] = useState();

  const doCopy = () => {
    navigator.clipboard.writeText(children);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <TextContainer onClick={doCopy}>
      <span>{copied ? "copied to clipboard" : children}</span>
      <CopyButton>
        <Icon icon="content-copy" width="16" height="16" />
      </CopyButton>
    </TextContainer>
  );
};
